import { extractCSSUnitNumericValue } from '@agilelab/plugin-wb-platform';

/**
 * Applies default styles to the template style object (defined in ui:style).
 * Applies the default properties only when not already defined in the template style object.
 * Makes also some adjustments on the defaults based on the provided template style.
 * @param style
 * @param defaultStyle
 * @returns
 */
export const applyDefaultsToTemplateStyle = (
  templateStyle: React.CSSProperties | undefined,
  defaultStyle: React.CSSProperties,
) => {
  if (!templateStyle) {
    return defaultStyle;
  }

  const computedStyle: React.CSSProperties = {
    ...defaultStyle,
    ...templateStyle,
  };

  const templateMaxWidth = extractCSSUnitNumericValue(templateStyle.maxWidth);

  const defaultMinWidth = extractCSSUnitNumericValue(defaultStyle.minWidth);

  /**
   * If we provide a default minWidth, we ensure that if the template sets a maxWidth
   * that is smaller than the default minWidth (and the template doesn't specify any minWidth to override the default one), we use the template maxWidth as
   * the default minWidth instead to avoid exceeding user defined maxWidth (because in css, if we provide minWidth > maxWidth, minWidth wins).
   */
  if (
    templateStyle.minWidth === undefined &&
    typeof templateMaxWidth === 'number' &&
    typeof defaultMinWidth === 'number' &&
    templateMaxWidth < defaultMinWidth
  ) {
    computedStyle.minWidth = templateStyle.maxWidth;
  }

  return computedStyle;
};
